//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SliderEncuesta",
  props: {
    value: {
      type: Number,
      default: 0
    },
    pregunta: String,
    min: Number,
    max: Number,
    bottom: String,
    top: String,
    readOnly: Boolean
  },
  data() {
    return {
      respuesta: this.value
    };
  },
  mounted() {
    this.respuesta = this.value;
    this.$emit("input", this.respuesta);
  },
  methods: {
    sendRespuesta(val) {
      this.respuesta = val;
      this.$emit("input", this.respuesta);
    }
  }
};
